const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class CanalApi {
  async getAllCanales() {
    const res = await fetch(api('canal'));
    if (!res.ok) throw new Error(`getAllCanales: ${res.status}`);
    return res.json();
  }

  async getMensajes(id_canal, id_usuario, offset = 0, limit = 20) {
    const res = await fetch(api(`mensaje/${id_canal}?user_id=${id_usuario}&offset=${offset}&limit=${limit}`));
    if (!res.ok) throw new Error(`getMensajes: ${res.status}`);
    return res.json();
  }

  async sendMensaje(id_canal, id_usuario, body, parent_id = null) {
    const res = await fetch(api('mensaje'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_canal, id_usuario, body, parent_id }),
    });
    if (!res.ok) throw new Error(`sendMensaje: ${res.status}`);
    return res.json();
  }

  async getReplies(id_canal, id_mensaje, id_usuario, offset = 0, limit = 30) {
    const res = await fetch(api(`mensaje/${id_canal}/${id_mensaje}/replies?user_id=${id_usuario}&offset=${offset}&limit=${limit}`));
    if (!res.ok) throw new Error(`getReplies: ${res.status}`);
    return res.json();
  }

  async deleteMensaje(id, id_usuario) {
    const userParam = id_usuario ? `?user_id=${id_usuario}` : '';
    const res = await fetch(api(`mensaje/${id}${userParam}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deleteMensaje: ${res.status}`);
    return { success: true };
  }

  async likeMensaje(id_mensaje, id_usuario) {
    const res = await fetch(api('mensaje/like'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_mensaje, id_usuario }),
    });
    if (!res.ok) throw new Error(`likeMensaje: ${res.status}`);
    return res.json();
  }

  async unlikeMensaje(id_mensaje, id_usuario) {
    const res = await fetch(api(`mensaje/like/${id_mensaje}/${id_usuario}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`unlikeMensaje: ${res.status}`);
    return { success: true };
  }

  async getPinnedMensaje(id_canal) {
    const res = await fetch(api(`mensaje/${id_canal}/pinned`));
    if (!res.ok) throw new Error(`getPinnedMensaje: ${res.status}`);
    return res.json();
  }

  async pinMensaje(id, pinned) {
    const res = await fetch(api(`mensaje/${id}/pin`), {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pinned }),
    });
    if (!res.ok) throw new Error(`pinMensaje: ${res.status}`);
    return res.json();
  }

  async checkLogro(id_usuario) {
    const res = await fetch(api(`logro/check/${id_usuario}`), { method: 'POST' });
    if (!res.ok) throw new Error(`checkLogro: ${res.status}`);
    return res.json();
  }
}
